import type { SVGProps } from 'react'

import { Wrapper } from './Wrapper'

export const IconHeaderLightbulb = (props: SVGProps<SVGSVGElement>) => (
	<Wrapper>
		<svg viewBox='0 0 267 220' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
			<path
				opacity='0.4'
				d='M131.667 175.809C130.145 175.809 128.661 175.867 127.217 175.983C116.058 176.814 107.6 180.815 107.6 185.614C107.6 190.412 116.058 194.389 127.217 195.244C128.658 195.352 130.142 195.418 131.667 195.418C145 195.418 155.725 191.026 155.725 185.614C155.725 180.201 145 175.809 131.667 175.809Z'
				fill='#CEBBB2'
			/>
			<path
				d='M131.667 159.139C130.142 159.139 128.658 159.206 127.217 159.313C138.383 160.144 146.842 164.145 146.842 168.944C146.842 173.742 138.383 177.719 127.217 178.574C128.658 178.682 130.142 178.748 131.667 178.748C145 178.748 155.725 174.357 155.725 168.944C155.725 163.531 145 159.139 131.667 159.139Z'
				fill='#0000FF'
			/>
			<ellipse cx='127.225' cy='168.944' rx='19.6167' ry='9.63019' fill='#3399FF' />
			<path
				d='M131.667 147.832C130.142 147.832 128.658 147.898 127.217 148.006C138.383 148.836 146.842 152.846 146.842 157.636C146.842 162.426 138.383 166.419 127.217 167.266C128.658 167.374 130.142 167.441 131.667 167.441C145 167.441 155.725 163.049 155.725 157.636C155.725 152.223 145 147.832 131.667 147.832Z'
				fill='#0000FF'
			/>
			<ellipse cx='127.225' cy='157.636' rx='19.6167' ry='9.6302' fill='#3399FF' />
			<path
				d='M131.667 137.081C130.142 137.081 128.658 137.147 127.217 137.255C138.383 138.086 146.842 142.087 146.842 146.886C146.842 151.684 138.383 155.661 127.217 156.516C128.658 156.624 130.142 156.69 131.667 156.69C145 156.69 155.725 152.298 155.725 146.886C155.725 141.473 145 137.081 131.667 137.081Z'
				fill='#0000FF'
			/>
			<ellipse cx='127.225' cy='146.886' rx='19.6167' ry='9.63019' fill='#3399FF' />
			<path
				opacity='0.5'
				d='M123.725 139.082C121.149 139.074 118.577 139.274 116.033 139.679C114.808 140.51 114.1 141.448 114.1 142.444C114.1 145.831 122.125 148.579 132.017 148.579C134.593 148.587 137.165 148.387 139.708 147.981C140.942 147.151 141.65 146.213 141.65 145.217C141.667 141.83 133.625 139.082 123.725 139.082Z'
				fill='#3399FF'
			/>
			<path
				d='M187.317 80.8602C187.308 53.6428 167.469 30.4569 140.494 26.1395C113.52 21.8222 87.3885 37.6504 78.8227 63.4954C70.2569 89.3405 81.79 117.558 106.042 130.09L114.1 142.444C114.1 145.831 122.125 148.579 132.017 148.579C141.908 148.579 149.942 145.831 149.942 142.444L157.275 130.09C175.74 120.566 187.329 101.575 187.317 80.8602Z'
				fill='#E5F2FF'
			/>
			<ellipse
				opacity='0.1'
				cx='50.9169'
				cy='47.0845'
				rx='50.9169'
				ry='47.0845'
				transform='matrix(0.13068 -0.991425 0.991552 0.129712 83.4995 125.575)'
				fill='#99CCFF'
			/>
			<path
				d='M136.5 143.241L147.858 102.562C148.132 101.592 147.593 100.579 146.633 100.262L144.733 99.6312C144.302 99.4886 144.01 99.0877 144.008 98.635V88.3406C144.01 87.3735 143.356 86.5273 142.417 86.2818L141.117 85.9497C140.479 85.7857 139.801 85.9242 139.28 86.3251C138.758 86.7259 138.452 87.3442 138.45 88.0002V105.077C138.45 105.773 138.108 106.424 137.535 106.822C136.962 107.219 136.23 107.312 135.575 107.07V107.07C134.742 106.758 134.19 105.964 134.192 105.077V86.1821C134.187 85.2826 133.618 84.4824 132.767 84.1814L132.117 83.9572C131.465 83.7279 130.743 83.8281 130.179 84.226C129.616 84.6239 129.282 85.2699 129.283 85.958V101.599C129.283 102.297 128.937 102.951 128.36 103.347C127.783 103.743 127.047 103.831 126.392 103.583L125.358 103.193C124.535 102.877 123.991 102.088 123.992 101.209V83.5753C123.992 82.6866 123.436 81.8918 122.6 81.5829L121.767 81.2757C121.114 81.0337 120.384 81.1253 119.813 81.521C119.241 81.9167 118.9 82.5663 118.9 83.2599V90.2667C118.899 90.6222 118.718 90.9533 118.419 91.1474C118.121 91.3415 117.743 91.3724 117.417 91.2297V91.2297C116.763 90.9392 116.001 91.0408 115.448 91.4923C114.894 91.9437 114.643 92.6678 114.8 93.3633L124.925 138.808'
				stroke='#F0C1AE'
				strokeWidth='2'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<ellipse
				opacity='0.3'
				cx='41.7316'
				cy='37.4413'
				rx='41.7316'
				ry='37.4413'
				transform='matrix(0.13068 -0.991425 0.991552 0.129712 82.0658 108.506)'
				fill='white'
			/>
		</svg>
	</Wrapper>
)
